import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'app-flag',
    templateUrl: './flag.component.html',
    styleUrls: ['./flag.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FlagComponent {
    constructor() {}

    @Input() code: string;

    @Input() codelist: string;

    getCountry() {
        return this.code ? _.toLower(this.code.substr(0, 2)) : null;
    }
}
